export default __webpack_public_path__ + "static/media/GMC.de7a4cfb.ico";